var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitwallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F04438",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3124_231541)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0562 20.5698C29.4918 20.4213 29.7247 19.9479 29.5762 19.5122L28.1478 15.3196C28.0132 14.9245 27.6069 14.6899 27.1973 14.7709L22.8523 15.6301C22.4008 15.7194 22.1071 16.1578 22.1964 16.6093C22.2857 17.0608 22.7241 17.3544 23.1756 17.2651L25.7191 16.7621L24.3456 19.141C21.6993 23.7246 15.8382 25.2951 11.2546 22.6488L10.172 22.0237C9.77346 21.7936 9.2638 21.9302 9.03368 22.3288C8.80356 22.7273 8.94012 23.237 9.3387 23.4671L10.4213 24.0921C15.8021 27.1987 22.6824 25.3551 25.789 19.9743L27.1624 17.5955L27.9986 20.0497C28.147 20.4854 28.6205 20.7182 29.0562 20.5698Z",
    fill: "#F04438"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3124_231541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.33984 23.6602) rotate(-60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitwallet);
export default __webpack_public_path__ + "static/media/debitwallet.2de7eb9197616dc098ee01a1f0be0544.svg";
export { ForwardRef as ReactComponent };